module.exports = __webpack_public_path__ + "static/media/lora.b14640a4.jpg";